import Auth from 'live/services/authorization'

export type Node = {
    key: string
    operation: string
    value: any
    nodes: Node[]
}

export const deepFind = (obj, path) => {
    const paths = path?.split('.') || [];
    let current = obj

    for (let i = 0; i < paths.length; ++i) {
        if (!current || current[paths[i]] == undefined) {
            return undefined;
        } else {
            current = current[paths[i]];
        }
    }
    return current;
}

export const formatDecimalNumber = (val: number) => {
    return val.toLocaleString().replaceAll(",", ".")
}

export const calcPercentage = (total: number, val: number): number => {
    if (total === 0) throw new Error('Arithmetic Error by dividing by zero')

    return Math.round((100 * val) / total)
}

export function formatNumber(phone: string): string {
    let mask = phone.replace(/\D/g, '')
    mask = mask.replace(/^(\d{2})(\d)/g, '($1) $2')
    mask = mask.replace(/(\d)(\d{4})$/, '$1-$2')

    return mask
}

export const canViewDrivers = (): boolean => {
    return (
        Auth.Permission.isAdmin ||
        Auth.Permission.ADMIN_ABLEON ||
        Auth.Permission.COMPANIES_ADMIN ||
        Auth.Permission.VIEW_DRIVER ||
        Auth.Permission.MANAGE_DRIVER
    )
}
export const canManageDrivers = (): boolean => {
    return (
        Auth.Permission.isAdmin ||
        Auth.Permission.ADMIN_ABLEON ||
        Auth.Permission.COMPANIES_ADMIN ||
        Auth.Permission.MANAGE_DRIVER
    )
}

export const isAbleOnAdmin = (): boolean => {
    return Auth.Permission.isAdmin || Auth.Permission.ADMIN_ABLEON
}

export type Row = WorkingTime & {
    uuid: string
}

export const objectsEqual = (o1: any, o2: any): boolean => {
    return typeof o1 === 'object' && Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
        : o1 === o2
}

export const arraysEqual = (a1: any[], a2: any[]) =>
    a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]))

export const isObjectEmpty = value => {
    return Object.prototype.toString.call(value) === '[object Object]' && JSON.stringify(value) === '{}'
}

export const removeDuplicatesBy = (arr: Array<any>, key: string) => {
    // return arr
    if (!arr) return
    return [...new Map(arr.map(item => [item[key], item])).values()]
}
export const removeDuplicates = (arr: Array<any>) => {
    if (!arr) return
    return arr.filter((item, index) => arr.indexOf(item) === index);
}